import JSONApiService from "@/services/JSONApiService";
import { REFEREE_MODEL } from "@/models/referee-model";

const refereeApi = ({ commit } = {}) => ({
  addNewReferee: async data =>
    JSONApiService(commit).create(REFEREE_MODEL, data),
  updateReferee: async data =>
    JSONApiService(commit)
      .one(REFEREE_MODEL, data.id)
      .patch(data)
});

export default refereeApi;
